import React from 'react'
import { ApolloProvider } from '@apollo/client'
import { RecoilRoot } from 'recoil'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import GlobalStyles from '@mui/material/GlobalStyles'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { CurrentUserContextProvider } from '../contexts/CurrentUserContext'
import theme from '../theme'
import ReportsPage from './ReportsPage'
import Report from './Report'
import { User, Tenant } from 'types'
import ReportFavorites from './ReportFavorites'
import { graphqlClient } from 'graphqlClient'
import ReportsYearPage from './ReportsYearPage'

const App: React.FC<{ currentUser: User; tenant: Tenant }> = ({
  currentUser,
  tenant,
}) => {
  return (
    <RecoilRoot>
      <ApolloProvider client={graphqlClient()}>
        <ThemeProvider theme={theme}>
          <CurrentUserContextProvider currentUser={currentUser} tenant={tenant}>
            <CssBaseline />
            <GlobalStyles styles={{ body: { backgroundColor: '#f6f6f6' } }} />
            <Router>
              <Routes>
                <Route path="/reports/:id" element={<Report />} />
                <Route
                  path="/reports/:id/sections/:sectionId"
                  element={<Report />}
                />
                <Route
                  path="/report_bookmarks/:id/sections/:sectionId"
                  element={<ReportFavorites />}
                />
                <Route path="/" element={<ReportsYearPage />} />
              </Routes>
            </Router>
          </CurrentUserContextProvider>
        </ThemeProvider>
      </ApolloProvider>
    </RecoilRoot>
  )
}

export default App
